import { useEffect } from "react"
import { useNavigate } from "react-router"

// TODO: Remove this dev-only page before merging to main.
const OAuthBackDev = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (window.location.hash) window.location.hash = ""
    navigate("/test-oauth-back", { replace: true })
  }, [navigate])

  return <div className="p-6">Processing...</div>
}

export default OAuthBackDev
